
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './lib/bootstrap';
import router from './router';

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import store from './store';
import CookiesBar from './views/widgets/CookiesBar.vue';
import OfflineNotification from './views/widgets/OfflineNotification.vue';
import ModalUser from './views/desktop/ModalUser.vue';
import ModalUserMobile from './views/desktop/ModalUserMobile.vue';
import RegisterModal from "./views/desktop/RegisterModal.vue";
import RecoverPasswordModal from "./views/desktop/RecoverPasswordModal.vue";
import ModalEvent from '@events/views/desktop/event/Modal.vue';
import ModalClub from '@clubs/views/desktop/club/Modal.vue';
import ModalBang from '@events/views/desktop/bang/Modal.vue';
import ModalSpot from '@events/views/desktop/spot/Modal.vue';
import ModalChat from '@chat/views/desktop/ModalChat.vue';
import ModalJoin from './views/widgets/ModalJoin.vue';
import ModalMeetNow from './views/widgets/ModalMeetNow.vue';
import ModalMobileChat from '@chat/views/mobile/ModalMobileChat.vue';
import ModalChatEvent from '@chat/views/desktop/ModalChatEvent.vue';
import ModalChatGroup from '@chat/views/desktop/ModalChatGroup.vue';
import ModalChatPreview from "@chat/views/widgets/ModalChatPreview.vue";
import ModalAdminPopUp from "@chat/views/widgets/ModalAdminPopUp.vue";
import HealthAlert from './views/widgets/HealthAlert.vue';
import Alert from './views/widgets/Alert.vue';
import Dialog from './views/widgets/Dialog.vue';
import Preloader from './views/widgets/Preloader.vue';
import Footer from './views/new/widgets/Footer.vue';
import GoogleFooter from './views/new/widgets/GoogleFooter.vue';
import ApolloClient from "apollo-boost"
import VueApollo from "vue-apollo"

import {initEchoListeners} from './lib/echoListener';
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported as isMessagingSupported } from "firebase/messaging";

window.store = store;

import i18n from '@general/lib/lang/init';
import { getUserLanguage, setUserLanguage } from '@general/lib/lang/helpers';

import discoverModule from "@discover/module/store/type";
import eventsModule from "@events/module/store/type";
import clubsModule from "@clubs/module/store/type";
import Vue from "vue";
import OneSignalVue from 'onesignal-vue'
import {VueReCaptcha} from "vue-recaptcha-v3";
import {mapStackTrace} from "sourcemapped-stacktrace";
import auth from '@general/lib/auth';
import AgeConfirmModal from "@buddy/views/widgets/AgeConfirmModal.vue";
import VerifyEmailModal from "@buddy/views/widgets/VerifyEmailModal.vue";
import MaintenanceModeModal from "@buddy/views/widgets/MaintenanceModeModal.vue"
import ModalVerifyAge from "./views/widgets/ModalVerifyAge.vue";

if (window.APP_ENV == 'local') {
    Vue.config.debug = true;
    Vue.config.devtools = true;
}

//TODO: send this to server for logging
/*Vue.config.errorHandler = function(err, vm, info) {
    console.error(err, vm, info);
    if(auth.isAuthenticated()){
        mapStackTrace(err.stack.toString(), function(mappedStack) {
            // do what you want with mappedStack here
            axios.post('/api/jserrors/log',{
                error : err.message + "\n" + mappedStack.join("\n")
            })
        });
    }
};*/

Vue.use(VueReCaptcha, {
    siteKey: window.RECAPTCHA_SITE_KEY,
})
Vue.use(OneSignalVue);

window.pageLoaded = false;

const app = new Vue({
    i18n,
    router,
    store,
    data: {
        isApplicationLoading: true,
        lang: getUserLanguage(),
        loading: false,
        distance: window.PRE_SEARCH_USERS_AROUND_KM,
        routesHistory: [],
        lastChatPage: '/chat',
        lastProfilePage: '/profile/edit',
        lastUsersAroundRefresh: moment(),
        lastEventsAroundRefresh: moment(),
    },
    mixins: [
        require('@general/lib/mixin').default,
    ],
    components: {
        'footer-widget': Footer,
        'google-footer-widget': GoogleFooter,
        'preloader': Preloader,
        'cookies-bar': CookiesBar,
        'offline-notification': OfflineNotification,
        'modal-user-desktop-component': ModalUser,
        'modal-user-mobile-component': ModalUserMobile,
        'modal-register-desktop-component': RegisterModal,
        'modal-recover-password-desktop-component': RecoverPasswordModal,
        'modal-event-desktop-component': ModalEvent,
        'modal-spot-desktop-component': ModalSpot,
        'modal-club-desktop-component': ModalClub,
        'modal-bang-desktop-component': ModalBang,
        'modal-chat-desktop-component': ModalChat,
        'modal-chat-mobile-component': ModalMobileChat,
        'modal-chat-event-desktop-component': ModalChatEvent,
        'modal-chat-group-desktop-component': ModalChatGroup,
        'modal-chat-preview': ModalChatPreview,
        'modal-join' : ModalJoin,
        'modal-meet-now' : ModalMeetNow,
        'modal-verify-email': VerifyEmailModal,
        'modal-verify-age': ModalVerifyAge,
        'modal-age-confirm': AgeConfirmModal,
        'modal-maintenance-mode': MaintenanceModeModal,
        'modal-admin-popup' : ModalAdminPopUp,
        'alert': Alert,
        'modal-dialog': Dialog,
        'health-alert': HealthAlert,
    },
    computed: {
        isLightLoading() {
            return this.loading == 'light'
        },
        requirementsAlert() {
            return this.$store.state.requirementsAlert
        },
        announceAlert() {
            return this.$store.state.announceAlert
        },
        isBuddyAtWork() {
            let atWork = false;

            return atWork
        }
    },
    methods: {
        tapped() {
            this.$store.commit('setTapped')
        },
        requirementsAlertRedirect() {
            this.$store.dispatch('requirementsAlertRedirect')
        },
        requirementsAlertHide() {
            this.$store.dispatch('requirementsAlertHide')
        },
        announceAlertHide() {
            this.$store.dispatch('announceAlertHide')
        },
        pushRouteHistory(url) {
            if (this.routesHistory[this.routesHistory.length - 1] != url) {
                this.routesHistory.push(url);
            }

            if (this.routesHistory.length > 40) {
                this.routesHistory = this.routesHistory.slice(-20);
            }
        },
        setLanguage(lang) {
            this.lang = lang; //for reactivity
            this.$validator.localize(lang); //for validations
            setUserLanguage(lang); //for storage
        },
        log() {
            if (process.env.NODE_ENV === 'development') {
                console.log.apply(console, arguments);
            }
        },
        showLoading(newLoad) {
            this.loading = !!newLoad;
        },
        showLightLoading(newLoad) {
            if (newLoad) {
                this.loading = 'light'
            } else {
                this.loading = false
            }
        },
        hideOnlyLightLoading() {
            if (this.loading == 'light') {
                this.loading = false
            }
        },
        isLoading() {
            return this.loading;
        },

        trans(word, args) {
            return this.$t(word, args);
        },

        addListeners() {
            // When window showing and hiding
            this.addWindowVisibilityListener()

            // Chat listeners, notifications listeners and etc.
            initEchoListeners();
        },
        checkDesktopRedirect(url) {
            if (url === '/register') {
                this.$router.push({name: 'home'});
            }
            if (url === '/recover-password') {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);

                const invalid_token = urlParams.get('invalid_token');
                this.$router.push({name: 'home',params: {invalid_key: invalid_token}});
            }
            if(url === '/barebuddy/register'){
                this.$router.push({name: 'home_barebuddy'});
            }
        },
        addWindowVisibilityListener() {
            let hidden, visibilityChange;

            if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
                hidden = "hidden";
                visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden";
                visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden";
                visibilityChange = "webkitvisibilitychange";
            }

            document.addEventListener(visibilityChange, () => {
                // Windows was hidden
                if (document[hidden]) {
                    console.log('[Poll] Window is hidden. Stop polling.')
                    store.dispatch('disableUserOnlineStatusPolling')

                // Windows was shown
                } else {
                    console.log('[Poll] Window is visible. Start polling.')
                    store.dispatch('enableUserOnlineStatusPolling')

                    // Update worker
                    window.workerReg && window.workerReg.update();

                    //clear badge
                    this.clearBadgeCounter();
                }
            });
        },
    },
    async created() {
        this.isApplicationLoading = true;
        console.log('[App] Created')
        await this.$store.dispatch('loadCurrentUserInfo').then(async() => {
            //app.$emit('profileLoaded', true)
            if(auth.isAuthenticated()){
                console.log('[Poll] App mounted. Profile loaded. Start polling.')
                store.dispatch('enableUserOnlineStatusPolling')

                // Load different filters from local storage
                await this.$store.dispatch(discoverModule.actions.filter.loadFromLocalStorage);
                await this.$store.dispatch(eventsModule.actions.initFilter);
                await this.$store.dispatch(clubsModule.actions.initFilter);

                //load my events
                this.$store.dispatch(eventsModule.actions.events.loadMy);
                //load available emojies
                this.$store.dispatch('getAvailableEmojies');
                //load events tags
                this.$store.dispatch('getSpotTags');
            }


            this.isApplicationLoading = false;
            this.verifyFirebasePlayer();
            console.log('[App] Loaded')
        })
    },
    mounted() {
        this.$recaptchaLoaded().then(() => {
            let currentUrl = this.$route.fullPath;
            const recaptcha = this.$recaptchaInstance;

            if (currentUrl === '/register') {
                recaptcha.showBadge()
            } else {
                recaptcha.hideBadge()
            }

        })

        console.log('[App] Mounted')

        // Add global listeners
        this.$nextTick(function(){
            this.addListeners();
            setTimeout(function() {
                window.pageLoaded = true;
            }, 1500);
        });

        //check non auth location
        if(localStorage.getItem('age_confirmed') && !localStorage.getItem('location') && !auth.isAuthenticated()){
            let self = this;
            this.decodeLocation(function (address){
                if(['UK','GB'].includes(address.country_code)){
                    location.reload();
                }else{
                    location.href = '/';
                }
            },function(){
                axios.post('/api/register/find-location')
                    .then(response => {
                        //all is good, no need to do anything
                    }).catch((e) => {
                        self.$store.dispatch('requirementsAlertShow', 'location')
                    })
            });
        }
    },
    beforeMount() {
        console.log('[App] Before mounted');
        const url = new URL(window.location.href);
        const currentUrl = url.pathname;

        if (app.isDesktop) {
            this.checkDesktopRedirect(currentUrl);
        }

        // Initialize Firebase
        const firebaseConfig = {
            apiKey: process.env.MIX_FIREBASE_API_KEY,
            authDomain: process.env.MIX_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.MIX_FIREBASE_PROJECT_ID,
            storageBucket: process.env.MIX_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.MIX_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.MIX_FIREBASE_APP_ID
        };
        const firebaseApp = initializeApp(firebaseConfig);
        isMessagingSupported().then((supported) => {
            if (supported) {
                console.log('[Firebase] Initting messages.');
                window.messaging = getMessaging(firebaseApp);
            } else {
                console.log('[Firebase] Messaging is not supported in this browser.');
                window.messaging = null;
            }
        });
    },
    mediaQueries: window.mediaQueries
});

window.app = app;

app.$mount('#app');
